import styled from 'styled-components';

export const Container = styled.hr`
  border-color: #00bcd4;
  opacity: 0.4;

  margin: 20px 8px;
`;
